import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobal } from '../../context/GlobalContext';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { userKey, isLoading } = useGlobal();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !userKey) {
      navigate('/');
    }
  }, [userKey, isLoading, navigate]);

  if (isLoading) return null;
  if (!userKey) return null;

  return <>{children}</>;
}
